// Should be sorted from the most important to the least important
export enum SoChipType {
  ERROR = "ERROR",
  IMPORTANT = "IMPORTANT",
  SUCCESS = "SUCCESS",
  DEFAULT = "DEFAULT",
  WARNING = "WARNING",
  FILTER = "FILTER",
  INACTIVE = "INACTIVE",
}
